import React from "react";

const Footer = () => {
    return <p className="footer">Site created using React and BlueprintJS</p>;
};

export default Footer;
